export default "__VITE_ASSET__470e672e__"